var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderHidden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1462 5.68787L12.0182 3.48157C11.6935 2.8466 11.5312 2.52909 11.289 2.29713C11.0748 2.09199 10.8167 1.93599 10.5333 1.8404C10.2129 1.7323 9.84991 1.7323 9.12396 1.7323H5.25886C4.12621 1.7323 3.55988 1.7323 3.12728 1.94787C2.74674 2.13749 2.43735 2.44005 2.24346 2.81219C2.02303 3.23527 2.02303 3.78909 2.02303 4.89675V5.68787M2.02303 5.68787H17.3932C19.0923 5.68787 19.9417 5.68787 20.5906 6.01122C21.1614 6.29565 21.6255 6.74948 21.9163 7.3077C22.247 7.94231 22.247 8.77306 22.247 10.4346V14.7857C22.247 16.4472 22.247 17.2779 21.9163 17.9125C21.6255 18.4707 21.1614 18.9246 20.5906 19.2089C19.9417 19.5323 19.0923 19.5323 17.3932 19.5323H6.87677C5.1778 19.5323 4.32831 19.5323 3.6794 19.2089C3.1086 18.9246 2.64451 18.4707 2.35367 17.9125C2.02303 17.2779 2.02303 16.4472 2.02303 14.7857V5.68787Z",
    stroke: "#636874",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 13,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4502 6.17647H6.31579V18.0432H18.4502V6.17647Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3832 16.4156C12.8615 16.4156 13.2983 16.3647 13.6967 16.2766L12.8084 15.4079C12.6704 15.4183 12.5303 15.4267 12.3832 15.4267C9.67769 15.4267 8.62959 13.525 8.37578 12.9544C8.56635 12.5385 8.82376 12.1551 9.13822 11.8187L8.4314 11.1275C7.65379 11.9517 7.35902 12.7818 7.35346 12.7983C7.31858 12.8998 7.31858 13.0096 7.35346 13.1112C7.36407 13.1438 8.52391 16.4156 12.3832 16.4156ZM12.3832 9.49333C11.4544 9.49333 10.6914 9.68914 10.0554 9.97839L8.19022 8.15487L7.4753 8.85402L16.576 17.754L17.291 17.0548L15.6129 15.4139C16.9345 14.4491 17.4063 13.1319 17.4134 13.1112C17.4483 13.0096 17.4483 12.8998 17.4134 12.7983C17.4023 12.765 16.2424 9.49333 12.3832 9.49333ZM14.8971 14.7137L13.7442 13.5864C13.8403 13.3936 13.8999 13.1815 13.8999 12.9544C13.8999 12.1431 13.2129 11.4711 12.3832 11.4711C12.1511 11.4711 11.9342 11.5295 11.7375 11.6239L10.8234 10.73C11.3252 10.5615 11.8526 10.4778 12.3832 10.4822C15.0887 10.4822 16.1367 12.3838 16.3905 12.9544C16.2379 13.2966 15.801 14.1125 14.8971 14.7137Z",
    fill: "#636874"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderHidden);
export default __webpack_public_path__ + "static/media/folder-hidden.153fd03de9323fe9f323a3a8cb7a5cf6.svg";
export { ForwardRef as ReactComponent };